module.exports = __webpack_public_path__ + "img/user-2.ac9f254f.jpg";